import React, { createContext, useCallback, useState } from 'react';
import { produce } from 'immer';
import { useAuthenticatedFormsLeadMutation, useAuthenticatedFormsUpdateLeadMutation, useAuthenticatedFormsCreateLeadMutation } from '../../hooks';
import AuthenticatedLeadFormsPayload from '../../utils/Data/AuthenticatedLeadFormsPayload';
import AuthenticatedLeadFormsResponseFunctions from '../../utils/Data/AuthenticatedLeadFormsResponse';
import { ToastType } from '../../containers/AuthenticatedLeadForms/types';
const NavigationContext = /*#__PURE__*/createContext({});
const NavigationContextProvider = _ref => {
  let {
    config,
    children,
    logUserEvent,
    logApiEvent,
    initialState,
    onComplete,
    accessToken,
    leadApiParams,
    request
  } = _ref;
  const {
    metadata: {
      type,
      stepNumber = 1,
      keyword
    }
  } = config || {
    metadata: {
      type: '',
      keyword: '',
      stepNumber: 1
    }
  };
  const {
    ErrorMessage
  } = AuthenticatedLeadFormsResponseFunctions;
  const [step, setStep] = useState(stepNumber);
  const [applicationId, setApplicationId] = useState('');
  const {
    screen,
    metadata
  } = config[step];
  const [selected, setSelected] = useState(initialState);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const initLead = useAuthenticatedFormsLeadMutation({
    leadApiParams,
    accessToken: accessToken,
    loanNumber: '',
    logApiEvent,
    logUserEvent,
    type,
    onComplete,
    setApplicationId,
    setIsApiLoading
  });
  const updateLead = useAuthenticatedFormsUpdateLeadMutation({
    leadApiParams,
    accessToken,
    logApiEvent,
    logUserEvent,
    type,
    onComplete
  });
  const submitLead = useAuthenticatedFormsCreateLeadMutation({
    leadApiParams,
    accessToken,
    logApiEvent,
    logUserEvent,
    type,
    onComplete,
    setIsApiLoading
  });
  const updateOrSubmitLead = useCallback((updatedPayload, isLastScreen, leadId) => {
    if (isLastScreen) {
      submitLead.mutate({
        requestBody: updatedPayload,
        applicationId: leadId
      });
    } else {
      updateLead.mutate({
        requestBody: updatedPayload,
        applicationId: leadId
      });
    }
  }, [submitLead, updateLead]);
  const createLead = useCallback(async isLastScreen => {
    if (type === 'AuthCashOut' || type === 'AuthRefi' || type === 'AuthPurchase') {
      var updatedPayload = '';
      switch (type) {
        case 'AuthCashOut':
          updatedPayload = AuthenticatedLeadFormsPayload.generateCashOutPayload(request, selected);
          break;
        case 'AuthRefi':
          updatedPayload = AuthenticatedLeadFormsPayload.generateRefinancePayload(request, selected);
          break;
        case 'AuthPurchase':
          updatedPayload = AuthenticatedLeadFormsPayload.generatePurchasePayload(request, selected);
          break;
      }
      if (!applicationId) {
        await initLead.mutateAsync({
          requestBody: updatedPayload,
          isLastScreen: isLastScreen
        }).then(result => {
          updateOrSubmitLead(updatedPayload, isLastScreen, result === null || result === void 0 ? void 0 : result.id);
        }).catch(() => {
          if (isLastScreen) {
            onComplete({
              message: ErrorMessage(type),
              toastType: ToastType.ERROR
            });
          }
        });
      } else {
        updateOrSubmitLead(updatedPayload, isLastScreen, applicationId);
      }
    }
  }, [type, applicationId, request, selected, initLead, updateOrSubmitLead, onComplete, ErrorMessage]);
  const onSelected = useCallback(_ref2 => {
    let {
      value,
      navigation
    } = _ref2;
    setSelected(produce(draft => {
      draft[step] = value;
    }));
    createLead(false);
    setTimeout(() => {
      setStep(navigation[navigation.action]);
    }, 500);
  }, [createLead, step]);
  return /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: {
      onSelected,
      total: config.metadata.steps,
      selected: selected[step],
      review: selected,
      screen,
      metadata,
      logUserEvent,
      logApiEvent,
      setStep,
      step,
      type,
      onComplete,
      accessToken,
      leadApiParams,
      request,
      keyword,
      applicationId,
      createLead,
      isApiLoading,
      setApplicationId,
      setIsApiLoading
    }
  }, children);
};
export { NavigationContextProvider, NavigationContext };
//# sourceMappingURL=index.js.map